import Color from "./color";

const components = {
  MuiInputBase: {
    styleOverrides: {
      input: {
        "&::placeholder": {
          color: "rgba(0, 0, 0, 0.1)",
          opacity: 1,
        },
      },
    },
  },
  MuiButtonBase: {
    defaultProps: {
      disableRipple: true,
      //  disableElevation: true,
    },
  },
  MuiLink: {
    defaultProps: {
      underline: "hover",
    },
  },
  MuiCardHeader: {
    defaultProps: {
      titleTypographyProps: {
        variant: "h6",
      },
    },
    styleOverrides: {
      action: {
        marginTop: "-4px",
        marginRight: "-4px",
      },
    },
  },
  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: "24px",
        background: "rgba(255, 255, 255, 0.05)",
        backdropFilter: "blur(12px)",
        border: "1px solid rgba(255, 255, 255, 0.1)",
        boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.5)",
        backgroundImage: "none",
      },
    },
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        borderRadius: "24px",
        background: "rgba(255, 255, 255, 0.05)",
        backdropFilter: "blur(12px)",
        border: "1px solid rgba(255, 255, 255, 0.1)",
        backgroundImage: "none",
        boxShadow: "none",
      },
    },
  },
  MuiPickersDay: {
    styleOverrides: {
      day: {
        fontWeight: "300",
      },
    },
  },
  MuiPickersYear: {
    styleOverrides: {
      root: {
        height: "64px",
      },
    },
  },
  MuiPickersCalendar: {
    styleOverrides: {
      transitionContainer: {
        marginTop: "6px",
      },
    },
  },
  MuiPickersCalendarHeader: {
    styleOverrides: {
      iconButton: {
        backgroundColor: "transparent",
        "& > *": {
          backgroundColor: "transparent",
        },
      },
      switchHeader: {
        marginTop: "2px",
        marginBottom: "4px",
      },
    },
  },
  MuiPickersClock: {
    styleOverrides: {
      container: {
        margin: `32px 0 4px`,
      },
    },
  },
  MuiPickersClockNumber: {
    styleOverrides: {
      clockNumber: {
        left: `calc(50% - 16px)`,
        width: "32px",
        height: "32px",
      },
    },
  },
  MuiPickerDTHeader: {
    styleOverrides: {
      dateHeader: {
        "& h4": {
          fontSize: "2.125rem",
          fontWeight: 400,
        },
      },
      timeHeader: {
        "& h3": {
          fontSize: "3rem",
          fontWeight: 400,
        },
      },
    },
  },
  MuiPickersTimePicker: {
    styleOverrides: {
      hourMinuteLabel: {
        "& h2": {
          fontSize: "3.75rem",
          fontWeight: 300,
        },
      },
    },
  },
  MuiPickersToolbar: {
    styleOverrides: {
      toolbar: {
        "& h4": {
          fontSize: "2.125rem",
          fontWeight: 400,
        },
      },
    },
  },
  MuiChip: {
    styleOverrides: {
      root: {
        borderRadius: "6px",
      },
    },
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        borderRadius: "16px",
        background: "rgba(255, 255, 255, 0.03)",
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "rgba(255, 255, 255, 0.1)",
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: "rgba(255, 255, 255, 0.2)",
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
          borderColor: "#6366f1",
          borderWidth: "1px",
        },
      },
      input: {
        padding: "12px 16px",
        color: "#f8fafc",
      },
    },
  },
  MuiInputLabel: {
    styleOverrides: {
      root: {
        color: "#94a3b8",
        "&.Mui-focused": {
          color: "#6366f1",
        },
      },
    },
  },
  MuiDialog: {
    styleOverrides: {
      paper: {
        borderRadius: "32px",
        background: "rgba(15, 23, 42, 0.8)",
        backdropFilter: "blur(20px)",
        border: "1px solid rgba(255, 255, 255, 0.1)",
        backgroundImage: "none",
        boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.5)",
        color: "#f8fafc",
      },
    },
  },
  MuiButton: {
    styleOverrides: {
      root: {
        borderRadius: "14px",
        textTransform: "none",
        fontWeight: 600,
        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      },
      contained: {
        background: "linear-gradient(135deg, #6366f1, #a855f7)",
        color: "#fff",
        boxShadow: "0 10px 15px -3px rgba(99, 102, 241, 0.3)",
        "&:hover": {
          background: "linear-gradient(135deg, #4f46e5, #9333ea)",
          transform: "translateY(-2px)",
          boxShadow: "0 20px 25px -5px rgba(99, 102, 241, 0.4)",
        },
      },
      outlined: {
        borderColor: "rgba(255, 255, 255, 0.1)",
        color: "#f8fafc",
        "&:hover": {
          background: "rgba(255, 255, 255, 0.05)",
          borderColor: "#6366f1",
        },
      },
    },
  },
  MuiDivider: {
    styleOverrides: {
      root: {
        borderColor: "rgba(255, 255, 255, 0.08)",
      },
    },
  },
  MuiSelect: {
    styleOverrides: {
      select: {
        borderRadius: "16px",
      },
      icon: {
        color: "#94a3b8",
      },
    },
  },
  MuiPopover: {
    styleOverrides: {
      paper: {
        borderRadius: "16px",
        background: "rgba(15, 23, 42, 0.95)",
        backdropFilter: "blur(12px)",
        border: "1px solid rgba(255, 255, 255, 0.1)",
        backgroundImage: "none",
      },
    },
  },
  MuiMenu: {
    styleOverrides: {
      list: {
        color: "#f8fafc",
      },
    },
  },
  MuiMenuItem: {
    styleOverrides: {
      root: {
        "&:hover": {
          background: "rgba(99, 102, 241, 0.1)",
        },
        "&.Mui-selected": {
          background: "rgba(99, 102, 241, 0.2)",
          "&:hover": {
            background: "rgba(99, 102, 241, 0.3)",
          },
        },
      },
    },
  },
};

export default components;
